module.exports = __webpack_public_path__ + "img/close.e2109df3.png";